import httpClient from '@/shared/lib/httpClient';
import { Agent, Session, SessionCreateRequest, SessionUpdateRequest, SessionDetail, SessionListResponse, SessionDeleteResponse, SessionForkRequest, SessionForkResponse } from '@/shared/types/session';

// Sessões
export async function createSession(data: SessionCreateRequest): Promise<Session> {
    return httpClient.post<Session>('/sessions', data);
}

export async function getUserSessions(): Promise<SessionListResponse> {
    return httpClient.get<SessionListResponse>('/sessions');
}

export async function getProjectSessions(projectId: string): Promise<Session[]> {
    const response = await httpClient.get<Session[] | { sessions?: Session[] }>(`/projects/${projectId}/sessions`);
    if (Array.isArray(response)) return response;
    return response.sessions || [];
}

export async function getSessionDetail(projectId: string, sessionId: string): Promise<SessionDetail> {
    return httpClient.get<SessionDetail>(`/projects/${projectId}/sessions/${sessionId}`);
}

export async function updateSession(projectId: string, sessionId: string, data: SessionUpdateRequest): Promise<Session> {
    return httpClient.put<Session>(`/projects/${projectId}/sessions/${sessionId}`, data);
}

export async function updateSessionStatus(projectId: string, sessionId: string, status: string): Promise<{ success: boolean; message: string }> {
    return httpClient.put<{ success: boolean; message: string }>(`/projects/${projectId}/sessions/${sessionId}/status`, { status });
}

export async function deleteSession(projectId: string, sessionId: string): Promise<SessionDeleteResponse> {
    return httpClient.delete<SessionDeleteResponse>(`/projects/${projectId}/sessions/${sessionId}`);
}

export async function addTableToSessionScope(projectId: string, sessionId: string, tableName: string): Promise<{ id: string; project_id: string; table_scope: string[] | null; success: boolean }> {
    return httpClient.post(`/projects/${projectId}/sessions/${sessionId}/table-scope`, { table_name: tableName });
}

export async function updateSessionTableScope(projectId: string, sessionId: string, tableScope: string[] | null): Promise<Session> {
    return httpClient.put<Session>(`/projects/${projectId}/sessions/${sessionId}`, { table_scope: tableScope });
}

export async function forkSession(
    projectId: string,
    sessionId: string,
    data?: SessionForkRequest
): Promise<SessionForkResponse> {
    return httpClient.post<SessionForkResponse>(
        `/projects/${projectId}/sessions/${sessionId}/fork`,
        data ?? {}
    );
}

// Legacy default export for backwards compatibility during migration
const SessionService = {
    createSession,
    getUserSessions,
    getProjectSessions,
    getSessionDetail,
    updateSession,
    updateSessionStatus,
    deleteSession,
    addTableToSessionScope,
    updateSessionTableScope,
    forkSession,
};

export default SessionService;